import * as React from 'react'

import { LitepaperView } from './Litepaper.view'

export const Litepaper = () => {
  return <LitepaperView />
}
